import Image from "next/image";
import Link from "next/link";
import styles from "./exploreMore.module.scss";
import { useTranslation } from "next-i18next";
import React from "react";
export default function ExploreMore() {
  React.useEffect(() => {
    import("lottie-interactive/dist/lottie-interactive.js");
  });
  const { t } = useTranslation("common");
  const IMG_URI = 'https://sthayyacrossingstg01.blob.core.windows.net/hayyacrossing-web-assets/';
  return (
    <section className={styles.exploreMore}>
      <div className=" pt-3 pb-3 text-white">
        <div className="container pb-sm-5">
          <div className="mb-4 text-center">
        <h2 className="sect-heading-x fz-40 text-dark fw-bold mt-3">{t("listofevents-heading")} </h2>
        <p className="text-dark mb-5">{t("listofevents-subheading")} </p>
        {/* <span><svg xmlns="http://www.w3.org/2000/svg" width="190" height="10" viewBox="0 0 190 10" fill="none">
  <path d="M0.669873 5L5 9.33013L9.33013 5L5 0.669873L0.669873 5ZM5 5.75H190V4.25H5V5.75Z" fill="#222222"/>
</svg></span> */}
        </div>
          <div className="row justify-content-center">
           {/* <div className="col-lg-3 col-md-6 mb-3 mb-md-0 d-flex flex-column pb-1">
              <Image
                src={IMG_URI + "hmp-fifa.png"}
                alt="host media accreditation"
                layout="responsive"
                width={499}
                height={550}
                className="curvey-img"
              />
          <div
                className={`${styles.contentInfo} bg-yellow p-3 `}
              >
                <div className="d-flex justify-content-between">
                <h5 className="d-flex align-center" style={{maxHeight: "43px"}}>{t("fifacardtitle")}</h5>
               
                </div>
                 <div className="text-dark mt-3">
                  <i className="event-date">{t("fifacarddate")}</i></div>
              </div>
            </div> */}
            <div className="col-lg-3 col-md-6 mb-3 mb-md-0 d-flex flex-column pb-1">
              <Image
                src={IMG_URI + "hmp-expo-img.png"}
                alt="expo-img"
                layout="responsive"
                width={499}
                height={550}
                className="curvey-img"

              />
            <div
                className={`${styles.contentInfo} bg-yellow  p-3`}
              >
                <div className="d-flex justify-content-between align-items-center">
                {/* <h4> {t("exploreQatar")}</h4> */}
                <h5 className="d-flex align-center">{t("expocardtitle")}</h5>
                <div className="">
                  <Link href="/about-qatar">
                    <a className="btn-diamond-x bg-orange-x text-white-x btn-r-arrow">
                      {/* {t("discoverMore")} */}
                      ➜
                    </a>
                  </Link>
                </div>
                </div>
                <span className="text-dark">{t("expo-event-location")}</span>
                <div className="text-dark"><i className="event-date">{t("expocarddate")}</i></div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 mb-3 mb-md-0 d-flex flex-column pb-1">
              <Image
                src={IMG_URI + "hmp-afc.png"}
                alt="afc-img"
                layout="responsive"
                width={499}
                height={550}
                className="curvey-img"
              />
            <div
                className={`${styles.contentInfo} bg-yellow  p-3`}
              >
                <div className="d-flex justify-content-between align-items-center">
                {/* <h4> {t("exploreQatar")}</h4> */}
                <h5 className="d-flex align-center">{t("afccardtitle")}</h5>
                <div className="">
                  <Link href="/about-qatar">
                    <a className="btn-diamond-x bg-orange-x text-white-x btn-r-arrow">
                      {/* {t("discoverMore")} */}
                      ➜
                    </a>
                  </Link>
                </div>
                </div>
                <span className="text-dark">{t("afc-event-location")}</span>

                <div className="text-dark"><i className="event-date">{t("afccarddate")}</i></div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 mb-3 mb-md-0 d-flex flex-column pb-1">
              <Image
                src={IMG_URI + "hmp-swim.png"}
                alt="swim-img"
                layout="responsive"
                width={499}
                height={550}
                className="curvey-img"

              />
              <div
                className={`${styles.contentInfo} bg-yellow  p-3`}
              >
                <div className="d-flex justify-content-between align-items-center">
                {/* <h4> {t("exploreQatar")}</h4> */}
                <h5 className="d-flex align-center">{t("equaticscardtitle")}</h5>
                <div className="">
                  <Link href="/about-qatar">
                    <a className="btn-diamond-x bg-orange-x text-white-x btn-r-arrow">
                      {/* {t("discoverMore")} */}
                      ➜
                    </a>
                  </Link>
                </div>
                </div>
                <span className="text-dark">{t("aquatic-event-location")}</span>
                <div className="text-dark"><i className="event-date">{t("equaticscarddate")}</i></div>
              </div>
            </div>
            {/* <div className={`col-md-4 d-none d-lg-block ${styles.lottie}`}>
              <lottie-interactive
                path="/assets/lottie/explore-more.json"
                interaction="play-on-show"
              />
            </div> */}
          </div>
        </div>
      </div>
    </section>
  );
}
